import React from "react";
export const formatLabel = (text) => {
  if (!text) return "";

  if (Array.isArray(text)) {
    text = text.join(", ");
  }

  return String(text)
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const FilterChip = ({ label, onRemove }) => {
  return (
    <span className="filter-chip">
      {formatLabel(label)}
      <button className="chip-close" onClick={onRemove}>
        ✕
      </button>
    </span>
  );
};
export default FilterChip;